import { Reveal } from "../components/Reveal";
import { SITE } from "../lib/site";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    testid: "privacy-policy-page",
    intro: `This Privacy Policy explains how ${SITE.name} ("we", "our", "us") collects, uses and protects information when you visit our website or contact us.`,
    sections: [
      { h: "Information We Collect", p: "When you contact us through our website, email, phone or WhatsApp, we collect your name, email address, phone number and the details of your enquiry. We do not collect payment information on this website." },
      { h: "How We Use Your Information", p: "We use the information you provide solely to respond to your enquiries, prepare project estimates, deliver our IT services and communicate with you about your project. We do not sell, rent or share your personal information with third parties for marketing purposes." },
      { h: "WhatsApp Communication", p: "If you choose to contact us via WhatsApp, your communication is governed by WhatsApp's own privacy policy in addition to this one. We use the official WhatsApp Business platform in compliance with WhatsApp's Business and Commerce policies." },
      { h: "Data Security", p: "We apply industry-standard technical and organisational measures — including encryption in transit and access controls — to protect your information against unauthorised access, alteration or disclosure." },
      { h: "Data Retention", p: "Enquiry records are retained only as long as necessary to fulfil the purpose for which they were collected, or as required by applicable Indian law." },
      { h: "Your Rights", p: `You may request access, correction or deletion of your personal information at any time by writing to ${SITE.email} or calling ${SITE.phoneDisplay}.` },
      { h: "Updates to This Policy", p: "We may update this Privacy Policy from time to time. The latest version will always be published on this page." },
    ],
  },
  terms: {
    title: "Terms of Services",
    testid: "terms-of-services-page",
    intro: `These Terms of Services govern your use of the ${SITE.name} website and the IT services we provide. By using this website or engaging our services, you agree to these terms.`,
    sections: [
      { h: "About Our Services", p: `${SITE.name} is an IT company based in ${SITE.address}, offering web development, mobile app development, cloud & DevOps, cybersecurity, AI automation and WhatsApp Business API integration services.` },
      { h: "Enquiries & Quotations", p: "Project estimates shared via email, phone or WhatsApp are indicative and valid for 15 days unless stated otherwise. A formal proposal and service-level agreement (SLA) is executed before any paid work begins." },
      { h: "Client Responsibilities", p: "Clients agree to provide accurate project requirements, timely feedback and any content or credentials required for delivery. Delays in inputs may extend agreed timelines." },
      { h: "Intellectual Property", p: "Upon full payment, the final deliverables created specifically for the client transfer to the client. We retain the right to reuse generic tools, libraries and know-how developed during the engagement." },
      { h: "Payments", p: "Projects are billed on a milestone basis as defined in the signed proposal. Invoices are payable within the terms stated on each invoice." },
      { h: "Limitation of Liability", p: "To the maximum extent permitted by law, our liability for any claim arising from our services is limited to the fees paid for the specific service giving rise to the claim." },
      { h: "Governing Law", p: `These terms are governed by the laws of India, with jurisdiction of the courts of Delhi. For any questions, contact us at ${SITE.email} or ${SITE.phoneDisplay}.` },
    ],
  },
};

const Legal = ({ type }) => {
  const c = CONTENT[type];
  return (
    <>
      <section className="bg-navy text-white py-20 sm:py-24 relative overflow-hidden grain" data-testid={`${type}-header`}>
        <div className="absolute inset-0 hero-grid" />
        <div className="relative max-w-4xl mx-auto px-5 sm:px-8">
          <p className="text-xs uppercase tracking-[0.3em] font-bold text-gold">{SITE.name} — Legal</p>
          <h1 className="mt-4 font-display text-4xl sm:text-5xl font-black tracking-tight" data-testid={`${type}-title`}>
            {c.title}
          </h1>
          <p className="mt-2 text-sm text-slate-500">Last updated: January 2026</p>
        </div>
      </section>
      <section className="bg-ivory py-16" data-testid={c.testid}>
        <div className="max-w-4xl mx-auto px-5 sm:px-8">
          <Reveal>
            <p className="text-slate-600 leading-relaxed">{c.intro}</p>
          </Reveal>
          <div className="mt-10 space-y-8">
            {c.sections.map((s, i) => (
              <Reveal key={s.h} delay={i * 0.04}>
                <div className="bg-white rounded-2xl border border-slate-200 p-7" data-testid={`${type}-section-${i}`}>
                  <h2 className="font-display text-xl font-bold text-ink">{i + 1}. {s.h}</h2>
                  <p className="mt-3 text-sm text-slate-600 leading-relaxed">{s.p}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Legal;
